<template>
  <hm-content title>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
    >商品链接
      <el-form-item label="广告名称：" prop="adName">
        <el-input
          type="text"
          v-model.trim="ruleForm.adName"
          clearable
          placeholder="请输入广告名称"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="广告描述：">
        <el-input
          v-model="ruleForm.adDescription"
          placeholder="请输入促销备注"
          type="textarea"
        ></el-input>
      </el-form-item>
      <el-form-item label="广告模板：" prop="templateType">
        <el-radio-group
          v-model="ruleForm.templateType"
          size="small"
          @change="switchTemp"
        >
          <el-radio v-for="(v, i) in adTempList" :key="i" :label="v.itemValue">
            {{ v.itemText }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item label="广告图片上传：" prop="adImg">
        <!-- <my-upload
          field="file"
          @crop-upload-success="cropUploadSuccess"
          v-model="show"
          v-if="show"
          noCircle
          noSquare
          :width="adImgWidth"
          :height="adImgHeight"
          :headers="{ 'X-Access-Token': $token }"
          :params="{ fileDir: 'advertisement' }"
          :url="$uploadUrl"
          img-format="png"
        ></my-upload> -->
        <el-button
          type="primary"
          size="small"
          v-show="!ruleForm.adImg"
          @click="toggleShow"
          >上传</el-button
        >
        <div class="priview" v-if="ruleForm.adImg">
          <img :src="ruleForm.adImg" alt="主图" />
          <div class="opreat-wrapper flex item-center flex-center">
            <el-button type="text" @click="handleRemove">删除</el-button>
          </div>
        </div>
        <div class="flex flex-column flex-end">
          <div class="form-item-tip">
            首页弹窗、优惠券弹窗、浮窗广告自定义尺寸
          </div>
          <div class="form-item-tip">全屏广告建议尺寸750×1334</div>
        </div>
      </el-form-item>
      <el-form-item label="广告排序：">
        <el-input
          @input="filterGt0OrFixed2('seqNum')"
          v-model="ruleForm.seqNum"
          size="small"
          placeholder="输入排序，数字越小，优先显示"
        ></el-input>
      </el-form-item>
      <el-form-item label="展示时间：" prop="validDate">
        <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          v-model.trim="ruleForm.validDate"
          type="datetimerange"
          align="right"
          :picker-options="pickerOptions"
          start-placeholder="活动开始时间"
          end-placeholder="活动结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
      </el-form-item>
      <el-form-item
        label="广告弹出频率："
        prop="showModel"
        v-if="ruleForm.templateType === 'full_screen'"
      >
        <el-radio-group v-model="ruleForm.showModel">
          <el-radio label="each">每次进入弹出</el-radio>
          <el-radio label="day">一日内首次进入弹出</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="商品链接" prop="linkUrl">
        <el-radio-group
          v-model="ruleForm.linkType"
          @change="openGoodsSelectSingle"
        >
          <el-radio label="page" :disabled="ruleForm.templateType === 'coupon' ||  ruleForm.templateType === 'registration_page' || ruleForm.templateType === 'live_page'"
            >页面</el-radio>
          <el-radio label="goods" :disabled="ruleForm.templateType === 'coupon' || ruleForm.templateType === 'registration_page' || ruleForm.templateType === 'live_page'"
            >商品</el-radio>
          <el-radio
            label="coupon"
            :disabled="ruleForm.templateType !== 'coupon'"
            >优惠券</el-radio>
          <el-radio label="miniProgram" :disabled="ruleForm.templateType === 'coupon' || ruleForm.templateType === 'registration_page' || ruleForm.templateType === 'live_page'"
          >小程序</el-radio>

          <el-radio label="marketing" :disabled="ruleForm.templateType === 'coupon' || ruleForm.templateType === 'registration_page' || ruleForm.templateType === 'live_page'"
            >营销活动</el-radio>



        </el-radio-group>
        <div class="flex item-center" v-if="ruleForm.linkType === 'page'">
          <span class="mr10">链接</span>
          <el-select
            size="small"
            clearable
            placeholder="选择页面"
            v-model="ruleForm.linkUrl"
            filterable
            allow-create
            default-first-option
            @change="selectGroup"
            v-if="!ruleForm.groupName"
          >
            <el-option
              v-for="(item, i) in microShopRouteList"
              :key="i"
              :label="item.hrefName"
              :value="item.hrefAddress"
            ></el-option>
          </el-select>
          <div v-if="ruleForm.groupName">
            <el-tag closable @close="handleClose" type="success">
              {{ ruleForm.groupName }}
            </el-tag>
          </div>
        </div>
        <div
          class="flex item-center"
          v-if="ruleForm.linkType === 'goods' && ruleForm.spuName"
        >
          <span class="mr10">商品</span>
          <el-tag closable @close="handleCloseSingle" type="success">{{
            ruleForm.spuName
          }}</el-tag>
        </div>

        <div
          class="flex item-center"
          v-if="ruleForm.linkType === 'marketing' && ruleForm.spuName"
        >
          <span class="mr10">活动名称</span>
          <el-tag closable @close="handleCloseSingle" type="success">{{
            ruleForm.spuName
          }}</el-tag>
        </div>



        <div
          v-if="ruleForm.linkType === 'coupon' && ruleForm.couponList.length"
        >
          <div class="table">
            <el-table border stripe size="mini" :data="ruleForm.couponList">
              <!-- <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="50"
                index
              ></el-table-column> -->
              <el-table-column
                header-align="center"
                align="center"
                prop="name"
                label="券名"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="levelMin"
                label="使用门槛"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="account"
                label="减免金额"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="isPlusFormat"
                label="会员类型"
              ></el-table-column>
              <el-table-column
                label="操作"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-tooltip class="item" content="删除" placement="top">
                      <div
                        class="pointer mr10"
                        @click="removeCoupon(scope.$index)"
                      >
                        <span class="hmicon icon-shanchu primary"></span>
                      </div>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="flex item-center" v-if="ruleForm.linkType === 'miniProgram'">
          <span style="width: 45px">appid</span>
          <el-input
              placeholder="请输入appid"
              v-model="ruleForm.appId"
              size="small"
              clearable>
          </el-input>
        </div>
        <div class="flex item-center" v-if="ruleForm.linkType === 'miniProgram'">
          <span style="width: 45px">链接</span>
          <el-input
              placeholder="请输入链接"
              v-model="ruleForm.linkUrl"
              size="small"
              clearable>
          </el-input>
        </div>
      </el-form-item>
      <el-form-item label="关闭按钮位置" prop="buttonClosePosition" v-if="ruleForm.templateType=='bottom_window'">
        <el-radio-group
          v-model="ruleForm.buttonClosePosition"
        >
          <el-radio label="rightUpper">右上</el-radio>
          <el-radio label="middleUpper">中上</el-radio>
          <el-radio label="leftUpper">左上</el-radio>
           <!-- <el-radio label="middleLower">中下</el-radio>
          <el-radio label="">右下</el-radio> -->
        </el-radio-group>
      </el-form-item>
      <el-form-item label="开启状态：">
        <el-switch
          v-model="ruleForm.enabledState"
          active-color="#2d8"
          active-text="开启"
          inactive-text="关闭"
          active-value="yes"
          inactive-value="no"
        ></el-switch>
      </el-form-item>
      <div class="flex flex-center">
        <el-button type="primary" size="small" @click="save('ruleForm')"
          >保存</el-button
        >
        <el-button size="small" @click="$router.back(-1)">返回</el-button>
      </div>
    </el-form>
    
    <hm-filter-micro-shop-marketing
      type="microShop"
      :visible="dialogVisibleMarketing"
      radio
      @setLink="setLinkMarketing"
      @close="dialogVisibleMarketing = false"
    ></hm-filter-micro-shop-marketing>


    <hm-filter-micro-shop-goods
      type="microShop"
      :visible="dialogVisible"
      radio
      @setLink="setLink"
      @close="dialogVisible = false"
    ></hm-filter-micro-shop-goods>



    <hm-filter-group-goods
      @saveGroupGoods="saveGroupGoods"
      @close="groupGoodsVisible = false"
      :visible="groupGoodsVisible"
    ></hm-filter-group-goods>
    <hm-filter-coupon
      :visible="selectCouponVisible"
      @saveCoupon="saveCoupon"
      @close="closeCoupon"
    ></hm-filter-coupon>
    <hm-upload
      :hmUploadVisible="show"
      fileDir="decoration"
      @cancleUpload="show = false"
      @hmUploadSuccess="hmUploadSuccess"
    ></hm-upload>
    <div id="dragContainer">
      <div class="preview-wrapper" id="dragbleElement">
        <div class="text-center">
          <el-button
            size="small"
            :type="isCollapse ? 'danger' : 'primary'"
            round
            @click="minimum"
          >
            <span class="hmicon icon-shouji"></span>
            <span>{{ isCollapse ? "点击展开" : "点击隐藏" }}</span>
            <span class="hmicon icon-youshuangjiantou arrow"></span>
          </el-button>
        </div>
        <transition name="fade">
          <div class="coupon-template" v-show="!isCollapse">
            <div class="phone-container">
              <div class="phone-header flex item-center">
                <i class="hmicon icon-guanbi1 minimum"></i>
                <span class="title">预览</span>
                <i class="hmicon icon-xuanxiang setting"></i>
              </div>
              <div class="phone-body">
                <div :class="ruleForm.templateType + '-wrapper'">
                  <div class="index-ad">
                    <img :src="ruleForm.adImg" alt="请先上传图片" />
                    <div
                      class="coupon-list"
                      v-if="ruleForm.templateType === 'coupon'"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import HmFilterMicroShopGoods from "@/components/HmFilterMicroShopGoods";
import HmFilterMicroShopMarketing from "@/components/HmFilterMicroShopMarketing";
import HmFilterGroupGoods from "@/components/HmFilterGroupGoods";
import HmFilterCoupon from "@/components/HmFilterCoupon";
import { drag } from "@/utils/utils";
import HmUpload from "@/components/HmUpload";

export default {
  components: {
    HmUpload,
    HmFilterMicroShopGoods,
    HmFilterMicroShopMarketing,
    HmFilterGroupGoods,
    HmFilterCoupon
  },
  computed: mapGetters(["microShopRouteList"]),
  data() {
    const patternFunc = function(rule, val, callback) {
      if (!this.ruleForm.adImg) {
        return callback(new Error("请上传广告"));
      }
      callback();
    }.bind(this);
    return {
      dialogVisibleMarketing: false,
      isCollapse: true,
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() < Date.now() - 8.64e7
          );
        }
      },
      previewList: [
        {
          key: "index",
          value: ""
        },
        {
          key: "coupon",
          value: ""
        },
        {
          key: "float",
          value: ""
        },
        {
          key: "full_screen",
          value: ""
        }
      ],
      selectCouponVisible: false,
      adTempList: [],
      show: false,
      groupGoodsVisible: false,
      dialogVisible: false,
      adImgWidth: 0,
      adImgHeight: 0,
      ruleForm: {
        linkType: "",
        spuName: "",
        adName: "",
        couponList: [],
        adDescription: "",
        templateType: "",
        adImg: "",
        seqNum: "",
        showEndTime: "",
        showStartTime: "",
        linkUrl: "",
        enabledState: "yes",
        groupName: "",
        showModel: "each",
        buttonClosePosition:'' //关闭按钮位置
      },
      rules: {
        linkUrl: {
          required: false,
          message: "请选择链接类型",
          trigger: "change"
        },
        adImg: {
          validator: patternFunc,
          trigger: "change"
        },
        validDate: {
          required: true,
          message: "请选择展示时间",
          trigger: "change"
        },
        templateType: {
          required: true,
          message: "请选择广告模板",
          trigger: "change"
        },
        adName: [
          {
            required: true,
            min: 2,
            max: 20,
            message: "名称应大于2小于20个字",
            trigger: "blur"
          }
        ],
        pasOutlets: {
          required: true,
          message: "请选择门店",
          trigger: "change"
        }
      }
    };
  },
  watch: {
    "ruleForm.linkType": {
      handler(val) {
        this.selectCouponVisible = val === "coupon";
        if (val !== "coupon") {
          this.ruleForm.couponList = [];
        }
      },
      deep: true
    }
  },
  created() {
    this.$store.dispatch("queryMicroShopList", {
      pageType: "page"
    });
    this.queryAdTempList();
  },
  mounted() {
    const dragbleElement = document.getElementById("dragbleElement");
    const dragContainer = document.getElementById("dragContainer");
    drag.startDrag(dragContainer, dragbleElement);
  },
  methods: {
    minimum() {
      this.isCollapse = !this.isCollapse;
    },
    handleClose() {
      this.ruleForm.groupName = "";
      this.ruleForm.linkUrl = "";
    },
    selectGroup(e) {
      if (e === "groupGoods") {
        this.groupGoodsVisible = true;
      }
    },
    saveGroupGoods(row) {
      this.groupGoodsVisible = false;
      this.ruleForm.linkUrl = `/pages/product/list?groupId=${row.groupId}`;
      this.ruleForm.groupName = row.groupName;
    },
    switchTemp(e) {
      this.ruleForm.linkType = "";
      switch (e) {
        // case "index":
        //   this.adImgWidth = 550;
        //   this.adImgHeight = 650;
        //   break;
        // case "float":
        //   this.adImgWidth = 160;
        //   this.adImgHeight = 160;
        //   break;
        case "coupon":
          if (!this.ruleForm.adImg) {
            this.ruleForm.adImg =
              "https://imgcdn.hemiao100.com/commission/psbff4ed56fa47024b-6c06-4da2-a6a6-401e10e065d7.png";
          }
          // this.adImgWidth = 668;
          // this.adImgHeight = 846;
          break;
        // case "full_screen":
        //   this.adImgWidth = 750;
        //   this.adImgHeight = 1334;
        //   break;
        default:
          break;
      }
    },
    async queryAdTempList() {
      const { result } = await this.$store.dispatch("queryAdTempList");
      this.adTempList = result;
    },
    handleRemove() {
      this.ruleForm.adImg = "";
    },
    handleCloseSingle() {
      this.ruleForm.spuName = "";
      this.ruleForm.linkUrl = "";
      this.ruleForm.linkType = "page";
    },
    // 营销活动
    setLinkMarketing(row) {
      console.log(row);
      this.ruleForm.linkUrl = row.url;
      this.ruleForm.spuName = row.gameName;  
      this.dialogVisibleMarketing = false;
    },
    setLink(row) {
      this.ruleForm.linkUrl = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      this.ruleForm.spuName = row.wxshopSpuName;
      this.dialogVisible = false;
    },
    saveCoupon(data) {
      this.selectCouponVisible = false;
      this.ruleForm.linkUrl = "/pages/coupon/coupon";
      this.ruleForm.couponList = data;
    },
    closeCoupon() {
      if (!this.ruleForm.couponList.length) {
        this.ruleForm.linkType = "";
      }
      this.selectCouponVisible = false;
    },
    removeCoupon(i) {
      this.ruleForm.couponList.splice(i, 1);
      this.closeCoupon();
    },
    openGoodsSelectSingle() {
      if (this.ruleForm.linkType === "goods") {
        this.dialogVisible = true;
        this.isRadio = true;
        // 为-1表示设置单个
        this.currentLinkIndex = -1;
      }

      if (this.ruleForm.linkType === "marketing") {
        this.dialogVisibleMarketing = true;
        this.isRadio = true;
        // 为-1表示设置单个
        this.currentLinkIndex = -1;
      }


      this.ruleForm.spuName = "";
      this.ruleForm.linkUrl = "";
      this.ruleForm.groupName = "";
      this.ruleForm.groupId = "";
    },
    filterGt0OrFixed2(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\./g, ""); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    async save(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        if (!this.ruleForm.linkUrl && (this.ruleForm.templateType != 'registration_page' && this.ruleForm.templateType != 'live_page')) {
          this.$message({
            type: "warning",
            message: "请选择链接或商品或优惠券"
          });
          return;
        }
        this.ruleForm.showStartTime = this.ruleForm.validDate[0];
        this.ruleForm.showEndTime = this.ruleForm.validDate[1];
        const params = JSON.parse(JSON.stringify(this.ruleForm));
        if (this.ruleForm.linkType === "coupon") {
          params.linkUrl = JSON.stringify(params.couponList);
          delete params.couponList;
        }
        const { code } = await this.$store.dispatch("addAd", params);
        if (code === "0") {
          this.$message({
            type: "success",
            message: "操作成功"
          });
          this.$router.back(-1);
        }
      }
    },
    hmUploadSuccess(url) {
      this.ruleForm.adImg = url;
      this.show = false;
    },
    toggleShow() {
      this.show = !this.show;
    }
  }
};
</script>
<style lang="scss" scoped>
.priview {
  position: relative;
  width: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.preview-wrapper {
  position: fixed;
  top: 100px;
  right: 30px;
  width: 365px;
  z-index: 10;

  .coupon-template {
    background-image: url("https://imgcdn.hemiao100.com/hemiaoBase/594db213-bcac-4e22-9df6-67832e131686.png");
    margin: 20px 20px 0;
    background-repeat: no-repeat;
    background-size: 100%;
    padding: 100px 16px;
    box-sizing: border-box;
    width: 375px;
    user-select: none;
    cursor: move;
    .phone-container {
      background: #fff;
      height: 595px;
      .phone-header {
        height: 44px;
        background: #fff;
        border-bottom: 1px solid #eeeeee;
        padding: 0 10px;

        .title {
          text-align: center;
          color: #333;
          font-size: 1.2rem;
        }
        .setting {
          text-align: right;
        }
      }
      .phone-body {
        position: relative;
        background: #f4f4f4;
        height: calc(100% - 45px);
        box-sizing: border-box;
        background: url("https://imgcdn.hemiao100.com/commission/e5bd0ecb98323b2ac6f0de88a5f1d08.png");
        background-size: 100% 100%;
      }
    }

    .currency,
    .logo {
      margin-top: 5px;
    }
  }
  .preview-button {
    .arrow {
      display: inline-block;
      transform: rotate(90deg);
    }
  }

  .index-wrapper,
  .register-wrapper,
  .payOrder-wrapper,
  .coupon-wrapper {
    .index-ad {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 300px;
      img {
        width: 100%;
      }

      .coupon-list {
        position: absolute;
        top: 100px;
        left: 50%;
        transform: translateX(-50%);
        background: url("https://imgcdn.hemiao100.com/commission/ps7ba623e9ff3a3593-8a6b-46b5-b769-a556f54923db.png");
        background-size: 100% 100%;
        width: 200px;
        height: 194px;
      }
    }
  }

  .float-wrapper {
    position: absolute;
    bottom: 60px;
    left: 20px;
    width: 86px;
    height: 76px;
    img {
      width: 100%;
    }
  }
  .full_screen-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    .index-ad {
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
